<div>
    <h2 class="userscreen-title">
        <button (click)="backClicked()" class="casino-back">Back</button></h2>
    <div>
        <div *ngIf="loading" class="loading-overlay">
            <mat-spinner diameter="50" mode="indeterminate"></mat-spinner>
        </div>
        <div *ngIf="is_active; else notActive">
            <iframe #gameIframe [src]="gameurl" title="game"
                    style="position:fixed; top:25px; left:0; bottom: 50px;; right:0; width:100%; height:97%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"></iframe>
        </div>
        <ng-template #notActive>
            <div class="pt-4 text-center" id="contact_us">
                <h3 class="alert alert-danger">Notice: Your casino account is not active, click to active.</h3>
                <br>
                <button type="button" [disabled]="clicked" (click)="activateAccount(); clicked = true;"
                        class="btn btn-primary btn-lg mt-3 text-dark">Activate account
                </button>
            </div>
        </ng-template>
    </div>
</div>